import React from 'react';
import global from "./data/global.json";
import {withLocalize} from "react-localize-redux";


function getPositionFromCoordinates(x, y, w, h, windowWidth) {
  if(windowWidth <= global.maxScreenSize.width) {
    let newHeight = (windowWidth / global.screenSize.width) * global.screenSize.height;
    let newWidth = windowWidth;
    let height = h === 'auto' ? 'auto' : `${Math.trunc((h / global.screenSize.height) * newHeight)}px`;

    return {
      left: `${Math.trunc((x / global.screenSize.width) * newWidth)}px`,
      top: `${Math.trunc((y / global.screenSize.height) * newHeight)}px`,
      width: `${Math.trunc((w / global.screenSize.width) * newWidth)}px`,
      height
    }
  } else {
    let newHeight = (global.maxScreenSize.width / global.screenSize.width) * global.screenSize.height;
    let newWidth = global.maxScreenSize.width;
    let height = h === 'auto' ? 'auto' : `${Math.trunc((h / global.screenSize.height) * newHeight)}px`;

    return {
      left: `${Math.trunc((x / global.screenSize.width) * newWidth)}px`,
      top: `${Math.trunc((y / global.screenSize.height) * newHeight)}px`,
      width: `${Math.trunc((w / global.screenSize.width) * newWidth)}px`,
      height
    }
  }
}

function convertWidth(width, windowWidth) {
  if(windowWidth <= global.maxScreenSize.width) {
    return `${Math.trunc((windowWidth / global.screenSize.width) * width)}px`;
  }
  else {
    return `${Math.trunc((global.maxScreenSize.width / global.screenSize.width) * width)}px`;
  }
}

function parseCoordinates(coordinates, type) {
  let x = undefined, y = undefined, w = undefined, h = undefined;

  let coordinateArray = coordinates.split(',');

  switch(type){
    case "rectangle": {
      x = coordinateArray[0];
      y = coordinateArray[1];
      w = coordinateArray[2];
      h = coordinateArray[3];
      break;
    }

    default:
      x = coordinateArray[0];
      y = coordinateArray[1];
      w = coordinateArray[2];
      h = coordinateArray[3];
    break;
  }

  return {
    x,
    y,
    w,
    h
  }
}


export function getFontSize(windowWidth){
  return global.baseFontSize  * (Math.min(global.maxScreenSize.width, windowWidth) / global.screenSize.width)
}

 export function withScenePosition(SceneComponent, defaults) {

   class PositionedSceneComponent extends React.Component {


     static getDerivedStateFromProps(props, state){


       let { windowWidth, type, coordinates, itemWidth1, itemWidth2, overrides, activeLanguage } = props;

       if(overrides && overrides[activeLanguage.code] && overrides[activeLanguage.code]['coordinates']){
        coordinates =  overrides[activeLanguage.code]['coordinates'];
       }

       let { x, y, w, h} = coordinates ? parseCoordinates(coordinates, type) : { ...props, ...defaults};
       let { left, top, width, height } = getPositionFromCoordinates(x, y, w, h, windowWidth);
       let newWidth1 = convertWidth(itemWidth1, windowWidth);
       let newWidth2 = convertWidth(itemWidth2, windowWidth);

       return {
         left: left,
         top: top,
         width: width,
         height: height,
         itemWidth1: newWidth1,
         itemWidth2: newWidth2
       }
     }

     cleanProps(overrides){
       let cleanProps = { ...this.props };

       if(overrides){
         cleanProps = { ...this.props, ...overrides };
       }

       delete cleanProps.x;
       delete cleanProps.y;
       delete cleanProps.coordinates;
       return cleanProps;
     }

     render() {
       let { top, left, width, height, itemWidth1, itemWidth2} = this.state;

       let { overrides, activeLanguage } = this.props;

       let cleanProps = this.cleanProps(overrides && overrides[activeLanguage.code] ? overrides[activeLanguage.code] : undefined)

       return <SceneComponent {...cleanProps} top={top} left={left} width={width} height={height} itemWidth1={itemWidth1} itemWidth2={itemWidth2} />
     }
   }

  return withLocalize(PositionedSceneComponent);
}





// WEBPACK FOOTER //
// ./src/scenePosition.js